module.exports = __webpack_public_path__ + "img/Time_Icon_UIA.6c692370.svg";